module.exports = __webpack_public_path__ + "img/toilet_wheelchair1.9b30cc30.png";